import {ICON_TYPES} from '../constants';

export const PixabayIcon = (): JSX.Element => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M13 2V9H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13ZM15 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3L0 11H15V0Z'
          fill='white'
        />
        <path
          d='M21 2C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V9H19V2H21ZM21 0H17V11H24V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.31607 21.7957 0 21 0Z'
          fill='white'
        />
        <path
          d='M5 15V22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V15H5ZM7 13H0V21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H7V13Z'
          fill='white'
        />
        <path
          d='M22 15V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H11V15H22ZM24 13H9V24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V13Z'
          fill='white'
        />
      </g>
    </svg>
  );
};

PixabayIcon.iconType = ICON_TYPES.PIXABAY;
